import Detect from './detect';

const DEBUG = false;

/**
* Helper functions that are used all around our application
*/
export default {
    computed: {
        /**
        * @return true - if device using the application is a mobile device
        */
        isMobile() {
            return Detect.isMobile();
        },
    }, // §.computer

    methods: {
        /**
        * Convert a hyphen-case string to a kebab-case string
        * for example 'this-is-my-string' into 'ThisIsMyString'
        */
        toPascalCase(str) {
            return str.replace(/(-\w)/g, m => m[1].toUpperCase());
        },

        humanTimespan(seconds) {
            if (seconds >= 120) {
                return moment().subtract(seconds, 'seconds').fromNow(true);
            }

            return this.$tc('generic.seconds', seconds);
        },

        // *** Common actions ***

        // @deprecated see snackbar.js
        snackbar(message, timeout) {
            return this.$root.$emit('show-snackbar', {
                message,
                timeout,
            });
        },

        // @deprecated see modal-loader.js
        showModalLoader(message) {
            this.$store.dispatch('ui/showModalLoader', message);
        },
        hideModalLoader() {
            this.$store.dispatch('ui/hideModalLoader');
        },

        // Monitor common actions
        pauseMonitor(id) {
            this.$root.gaEngagement('pause_monitor');
            if (id) {
                return this.pause(parseInt(id, 10))
                    .then(() => this.snackbar('Monitor has been disabled.'));
            }
            return this.pause(this.$route.params.id)
                .then(() => this.snackbar('Monitor has been disabled.'));
        },
        resumeMonitor(id) {
            this.$root.gaEngagement('resume_monitor');
            if (id) {
                return this.resume(parseInt(id, 10))
                    .then(() => this.snackbar('Monitor has been enabled.'))
                    .catch((error) => {
                        if (typeof error.response !== 'undefined' && error.response.status === 402) {
                            return this.snackbar('You cannot enable more monitors, please upgrade your plan.');
                        }
                        return this.snackbar('We are having issues enabling your monitor, please try again later!');
                    });
            }
            return this.resume(this.$route.params.id)
                .then(() => this.snackbar('Monitor has been enabled.'))
                .catch((error) => {
                    if (typeof error.response !== 'undefined' && error.response.status === 402) {
                        return this.snackbar('Cannot enable monitor, please upgrade your plan.');
                    }
                    return this.snackbar('We are having issues enabling your monitor, please try again later!');
                });
        },
        deleteMonitorConfirmation() {
            this.$root.gaEngagement('delete_monitor');
            this.deleteDialog = true;
        },

        // Google Analytics

        gaEngagement(action, label, extras) {
            if (DEBUG) console.log('⭐️ engagement', action, label);
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: 'sendEvent',
                    eventCategory: 'engagement',
                    eventAction: action,
                    eventLabel: label,
                    ...extras,
                });
            }
        },

        gaInteraction(action, label) {
            if (DEBUG) console.log('⭐️ interaction', action, label);
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: 'sendEvent',
                    eventCategory: 'interaction',
                    eventAction: action,
                    eventLabel: label,
                });
            }
        },

        gaExperience(action, label) {
            if (DEBUG) console.log('⭐️ experience', action, label);
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: 'sendEvent',
                    eventCategory: 'experience',
                    eventAction: action,
                    eventLabel: label,
                });
            }
        },

        // Form handling helpers
        // @deprecated see forms.js
        retrieveErrors(response, fields) {
            // reseponse.data.errors contains an array
            // with status (422), detail ("The ... format is invalid")
            // and source.pointer in the format /data/attributes/settings/url
            const errors = {};
            _.forEach(response.data.errors, (item) => {
                // convert slashes into dots
                const attribute = item.source.pointer.replace(/\//g, '.').substring(1);
                errors[attribute] = item.detail.replace(attribute, fields[attribute]);
            });
            return errors;
        },

        getError(pointer) {
            if (typeof this.errors[pointer] !== 'undefined' && this.errors[pointer]) {
                return this.errors[pointer];
            }
            return null;
        },
    }, // §.methods
};
